import { MarkdownContent } from "@/components/MarkdownContent";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ReasoningPaneProps {
  reasoning: string;
}

export default function ReasoningPane({ reasoning }: ReasoningPaneProps) {
  return (
    <MarkdownContent
      content={reasoning || "N/A"}
      components={{
        a: ({ href, children }) => (
          <Tooltip>
            <TooltipTrigger asChild>
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            </TooltipTrigger>
            <TooltipContent>
              <p className="max-w-xs truncate">{href}</p>
            </TooltipContent>
          </Tooltip>
        ),
      }}
    />
  );
}
